import React, {useEffect} from 'react';
import {observer} from 'mobx-react-lite';

import styles from './styles.module.scss';
import MainPage from './Pages/Main.page';
import {Pages} from './consts';
import ReportGeneratorPage from './Pages/Report.page';
import {CustomQueryClientProvider} from '../../hooks/useQueryClientProvider';
import Header from './componenets/Header';
import {useReportQuery} from './useReportsQuery';
import {reportGeneratorsStore} from './stores/ReportGeneratorsStore';
import {featuresIDs, shouldShowFeature} from '../FeaturePopover/constants/map';
import {updateBlackList} from '../FeaturePopover/actions/feature';
import {analyticsInitAutomationExport} from './AutomationExports';
import ChartGeneratorPage from './Pages/Chart.page';
import ChartDisplayPage from './Pages/ChartDisplay.page';

const AnalyticsComp = observer(() => {
    const {currentScreen, close} = reportGeneratorsStore;
    const {isLoading} = useReportQuery(currentScreen);

    useEffect(() => {
        if (shouldShowFeature(featuresIDs.analytics) || shouldShowFeature(featuresIDs.analytics2)) {
            updateBlackList(featuresIDs.analytics);
            updateBlackList(featuresIDs.analytics2);
        }
        analyticsInitAutomationExport();
    }, []);

    return (
        <div className={styles.container}>
            <Header onClose={() => close(currentScreen.session)} />
            {currentScreen.currentPage === Pages.main && <MainPage isLoading={isLoading} />}
            {currentScreen.currentPage === Pages.report && <ReportGeneratorPage />}
            {currentScreen.currentPage === Pages.chart && <ChartGeneratorPage />}
            {currentScreen.currentPage === Pages.chartDisplay && <ChartDisplayPage />}
        </div>
    );
});

export const Analytics = () => (
    <CustomQueryClientProvider>
        <AnalyticsComp />
    </CustomQueryClientProvider>
);
